import React, { useState, useEffect, useCallback } from 'react';
import { useForm, Controller, useFormState } from 'react-hook-form';
import classNames from 'classnames/bind';
import RegisterFormInput from 'components/RegisterFormInput/RegisterFormInput';
import styles from './EditMonthlyandExpenditure.module.scss';
import { parseRawNumber, formatNumber } from 'templates/IncomeAndExpendituresPageData/Utils/FormatNumbers'
import http from 'app/http';
import qs from 'qs';
import { useHistory } from 'react-router-dom';
import { FormatMoney, parseStringAmountToFloat } from 'common/helpers/numberHelper';
import PageLink from 'components/PageLink/PageLink';
import { formProgression } from 'common/helpers/Gtm';

interface Props {
  PageData?: any;
  Model?: any;
  layoutModel?: any;
  closePop: Function;
  instalmentValue: number;
  setAvailableIncome?: any;
  availableIncome?: any;
}

const EditMonthlyIncomeandExpenditure = ({ closePop, PageData, Model, instalmentValue, layoutModel, setAvailableIncome,availableIncome }: Props) => {
  const [totalIncome, setTotalIncome] = useState<string>(Model?.DisposableFormModel?.TotalIncome);
  const [totalExpense, setTotalExpense] = useState<string>(Model?.DisposableFormModel?.TotalExpense);
  const history = useHistory();
  let cleanUpRegex = /^[., 0-9€£zł]+$/g;
  const {
    control,
    setValue,
  } = useForm({
    defaultValues: {
      DisposableFormModel: {
        TotalIncome: FormatMoney(
          parseStringAmountToFloat(Model?.DisposableFormModel?.TotalIncome || '0'),
          Model?.FormattedCurrencySymbol, layoutModel?.IsCurrencyOnTheLeftSide,
          layoutModel?.DecimalSeparatorForNumberFormatter),
        TotalExpense: FormatMoney(
          parseStringAmountToFloat(Model?.DisposableFormModel?.TotalExpense || '0'),
          Model?.FormattedCurrencySymbol, layoutModel?.IsCurrencyOnTheLeftSide,
          layoutModel?.DecimalSeparatorForNumberFormatter),
        DisposableIncome: Model?.DisposableFormModel?.DisposableIncome || 0
      }
    }
  });

  const amountChange = useCallback(
    (e: any, callback: Function) => {
      callback(e.target.value);
      let match = e.target.value.match(cleanUpRegex);
      if (e.target.value !== null && match != null) {
        if (e.target.name == "DisposableFormModel.TotalIncome") {
          setTotalIncome(e.target.value);
          setValue("DisposableFormModel.TotalIncome", e.target.value);
        }
        else if (e.target.name == "DisposableFormModel.TotalExpense") {
          setTotalExpense(e.target.value);
          setValue("DisposableFormModel.TotalExpense", e.target.value);
        }
      }
      else {
        setAvailableIncome("");
      }
    },
    [totalIncome, totalExpense],
  );

  const handleClick = useCallback(
    (e: any) => {
      if (e.target.name == "DisposableFormModel.TotalIncome") {
        if (parseStringAmountToFloat(e.target.value) == 0) {
          e.target.value = "";
          setTotalIncome(e.target.value);
          setValue("DisposableFormModel.TotalIncome", e.target.value);
          setAvailableIncome("");
        }
      }
      else if (e.target.name == "DisposableFormModel.TotalExpense") {
        if (parseStringAmountToFloat(e.target.value) == 0) {
          e.target.value = "";
          setTotalExpense(e.target.value);
          setValue("DisposableFormModel.TotalExpense", e.target.value);
          setAvailableIncome("");
        }
      }
    },
    [totalIncome, totalExpense],
  );

  const getPathnameFromUrl = (url: string) => {
    const link = new URL(url);
    return link.pathname + link.search;
  };
  const formSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const response =
        await http.post(
          Model?.PostDisposableIncomePageUrl,
          qs.stringify({
            'DisposableFormModel.DisposableIncome': availableIncome,
            'DisposableFormModel.TotalIncome': totalIncome,
            'DisposableFormModel.TotalExpense': totalExpense
          })
        );

      if (response && response.data) {
        let nextPagePath = '';
        if (!response.data.RedirectUrl) {
          nextPagePath = getPathnameFromUrl(response.data.RedirectUrl);
        } else {
          nextPagePath = getPathnameFromUrl(response.data.RedirectUrl);
        }
        history.push(nextPagePath, {
          noRefresh: false,
        });
      }
    }
    catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if(parseRawNumber(totalIncome, 2) > 0 && (parseRawNumber(totalExpense, 2)) > 0)
    {
    let avilableIncomeValue = (parseRawNumber(totalIncome, 2) -
      (parseRawNumber(totalExpense, 2)));

    avilableIncomeValue = avilableIncomeValue < 0 ? 0 : avilableIncomeValue;

    setAvailableIncome(avilableIncomeValue.toString());
    }
  }, [totalIncome, totalExpense]);
  const getCurrencyClass = () => {
    var currencyClass = "Icon-euro--before";

    if (Model.DisplayedCurrency === 'PLN') {
      currencyClass = "Icon-zt--before";
    }
    else if (Model.DisplayedCurrency === 'GBP') {
      currencyClass = "Icon-ps--before";
    }
    return currencyClass;
  }
  return (
    <form onSubmit={formSubmit}>
      <div className="modal-content">
        <a
          href="javascript:void(0)"
          className="modal-close"
          onClick={() => closePop(false)}
        ></a>
        <div className="u-textCenter">
          <h3 className="Heading Heading-h3--portal u-marginBz">
            {PageData?.MonthIncomeExpenditureHeading}
          </h3>

          <p className="Text--small u-marginTxxsm">
            {PageData?.MonthIncomeExpenditureDetails}
          </p>
        </div>
        <hr className="vertical_line" />
        <div>
          <Controller
            control={control}
            name={'DisposableFormModel.TotalIncome'}
            render={({
              field: { onChange, name, value },
            }) => {

              return (
                <>
                  <RegisterFormInput
                    name={name}
                    value={value}
                    label={PageData?.TotalHouseholdIncomeLabel}
                    placeholder="0.0"
                    onChange={
                      (e: any) => amountChange(e, onChange)
                    }
                    onClick={(e: any) => handleClick(e)}
                    tooltipMessage={PageData?.TotalHouseholdIncomeTooltip}
                    tooltipId="TotalHouseholdIncomeTooltip"
                    explicationMessage=" "
                    currencyClass={getCurrencyClass()}
                    showCurrency={true}
                    onBlur={(e)=>{formProgression(e,'ShortIEForm','TotalIncome')}}
                  />
                </>
              );
            }}
          />
        </div>
        <div>
          <Controller
            control={control}
            name={'DisposableFormModel.TotalExpense'}
            render={({
              field: { onChange, name, value },
            }) => {

              return (
                <>
                  <RegisterFormInput
                    name={name}
                    value={value}
                    label={PageData?.ExpenditureIncludingOtherDebtLabel}
                    placeholder="0.0"
                    onChange={
                      (e: any) => amountChange(e, onChange)
                    }
                    onClick={(e: any) => handleClick(e)}
                    tooltipMessage={PageData?.ExpenditureIncludingOtherDebtTooltip}
                    tooltipId="ExpenditureIncludingOtherDebtTooltip"
                    explicationMessage=" "
                    currencyClass = {getCurrencyClass()}
                    showCurrency={true}
                    onBlur={(e)=>{formProgression(e,'ShortIEForm','TotalExpense')}}
                  />
                </>
              );
            }}
          />
        </div>

        <div className={styles.finalsection}>
          <div className={styles.heading}>{PageData?.RemainingMonthlyIncomeLabel}</div>
          <div className={styles.amount}>{FormatMoney(
            parseStringAmountToFloat(availableIncome || "0"), Model?.FormattedCurrencySymbol, layoutModel?.IsCurrencyOnTheLeftSide, layoutModel?.DecimalSeparatorForNumberFormatter)}</div>
        </div>
        {Model?.IsUtilityCustomer &&
          (
            <div className={styles.monthly_info}>
              <p className="u-textCenter">
                {PageData?.NeedhelpToWorkoutLabel}
                <PageLink url={Model?.IncomeAndExpenditurePageUrl} className={styles.linktext} text={PageData?.MonthIncomeExpenditureHeading}
                />
              </p>
            </div>
          )}
        <div className={styles.currentmonth}>
          <p>{PageData?.CurrentMonthPaymentText}</p>
          <span>{isNaN(instalmentValue) ? FormatMoney(
            parseStringAmountToFloat(instalmentValue || "0"), Model?.FormattedCurrencySymbol, layoutModel?.IsCurrencyOnTheLeftSide, layoutModel?.DecimalSeparatorForNumberFormatter) :
            typeof (instalmentValue) == 'string' ? FormatMoney(
              (parseFloat(instalmentValue) || 0), Model?.FormattedCurrencySymbol, layoutModel?.IsCurrencyOnTheLeftSide, layoutModel?.DecimalSeparatorForNumberFormatter) :
              FormatMoney(
                (instalmentValue || 0), Model?.FormattedCurrencySymbol, layoutModel?.IsCurrencyOnTheLeftSide, layoutModel?.DecimalSeparatorForNumberFormatter)}</span>
        </div>
        <div className="u-marginTmd u-textCenter">
          <button className="Button u-block w-100 u-marginBxxsm" type="submit">{PageData?.SaveButtonText}</button>
        </div>
      </div>
    </form>
  );
};
export default EditMonthlyIncomeandExpenditure;
